import { useAuth } from '@hb/react'
import { ASSESSMENT_INVOICE_SNIPPETS, AssessmentInvoiceSnippet } from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../backend/db/hooks/useDocument'

export const useAssessmentInvoiceSnippets = (assessmentId: string | undefined | null) => {
  const role = useAuth(s => s.role)
  const passedId = useMemo(
    () => (role === 'super-admin' && assessmentId ? assessmentId : null),
    [assessmentId, role],
  )
  const { data, ...passed } = useDocument<Record<string, AssessmentInvoiceSnippet>>(
    ASSESSMENT_INVOICE_SNIPPETS,
    passedId,
  )
  const { id: _id, ...rest } = data ?? {}
  return { data: rest, ...passed }
}
